<template>
  <v-card dflex>
    <v-toolbar color="primary" flat dark prominent>
      <v-toolbar-title>{{ dealer.name }}</v-toolbar-title>
      <v-spacer/>
      <v-card-subtitle class="white--text">Sales and Service by Postal Code</v-card-subtitle>
      <v-btn
        color="primary"
        fab
        right
        x-small
        elevation="0"
        v-on:click.prevent="$emit('close-report')"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :headers="tableHeaders"
        :items="postalData"
      >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { downloadViaLinkCreated, hasValue } from '@/utils'
import { ReportsApi } from '@/services'
import Titleize from '../../filters/titleize'
import { DateTime } from 'luxon'

export default {
  name: 'sale-service-by-postal-report',
  components: { },
  props: {
    // when set to true, indicate report should be executed now
    runReport: {
      required: true,
      type: Boolean
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    },
    customerType: {
      type: String,
      default: 'people'
    },
    outputFormat: {
      type: String,
      required: false,
      default: 'html'
    }
  },
  data: function () {
    return {
      postalData: [],
      tableHeaders: [],
      dollarTextShrink: {
        default: {
          // width: 200,
          valueClass: 'headline ml-2 mb-8'
        }
      }
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    fStartDate () {
      return this.dateVerboseMDY(this.startDate)
    },
    fEndDate () {
      return this.dateVerboseMDY(this.endDate)
    }
  },
  watch: {
    runReport (newVal, oldVal) {
      if (newVal) {
        this.loadReportData()
      }
    }

  },
  methods: {
    shouldDownload () {
      return ['csv', 'excel'].includes(this.outputFormat)
    },
    dateVerboseMDY (date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED)
    },
    validate () {
      if (hasValue(this.startDate) && hasValue(this.endDate) && hasValue(this.customerType)) {
        return true
      } else {
        throw new Error('Invalid/Missing Parameters')
      }
    },
    setTableData (data) {
      // { text: '', value: ''}
      if (data.length > 0) {
        this.tableHeaders = Object.keys(data[0]).map(col => {
          return { text: Titleize.titleize(col), value: col }
        })
      }
      this.postalData = data
    },
    async loadReportData () {
      this.$logger.trace('Loading Sales and Service counts by Postal Code')
      try {
        this.validate()
        const rptParams = {
          name: 'SaleServiceByPostalCode',
          dealer_id: this.dealer.id,
          start_date: this.startDate,
          end_date: this.endDate,
          customer_type: this.customerType,
          include_backing_data: true, // doesn't matter what value - always same report
          output_format: this.outputFormat
        }
        const rptData = await ReportsApi.generateReport(rptParams)
        if (this.shouldDownload()) {
          downloadViaLinkCreated(rptData.data.csv_url)
        } else {
          this.setTableData(rptData.data)
        }

        this.$emit('report-complete', { status: 'ok' })
      } catch (error) {
        this.$logger.error('Error Fetching report', error.message)
        this.$emit('report-complete', { status: 'error', message: error.message })
      }
    }
  }

}
</script>
